import { ExtendedContainer, TerminalContainer } from '../adapters/crpAPI';

export const mapExtendedContainerToTerminalContainer = (
  extendedContainer: ExtendedContainer
): TerminalContainer => {
  return {
    releaseId: extendedContainer.releaseId,
    receivedFromNxtEntityId: extendedContainer.releaseFromNxtEntityId!,
    receivedFromName: '',
    equipmentNumber: extendedContainer.equipmentNumber,
    billOfLadingNumbers: extendedContainer.billOfLadingNumbers,
    terminalOperationColor: extendedContainer.terminalOperation?.color!,
    terminalOperationValue: extendedContainer.terminalOperation?.greenLightValue!,
    terminalReadyColor: extendedContainer.terminalReady?.color!,
    terminalReadyValue: extendedContainer.terminalReady?.greenLightValue!,
    customsColor: extendedContainer.customsLight?.color!,
    customsValue: extendedContainer.customsLight?.greenLightValue!,
    imoNumber: extendedContainer.imoNumber ?? '',
    stayNumber: extendedContainer.stayNumber ?? '',
    meansOfTransport: extendedContainer.meansOfTransport ?? '',
    shippingAgentName: extendedContainer.shippingAgentName ?? '',
    terminalName: extendedContainer.terminalName,
    shippingAgentNxtEntityId: '',
  };
};
